import React, { useEffect, useState } from 'react'
import { useSelectorCustom } from '../../../components/general/general-component/abstruct-component/useSelectorCustom'
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar'
import { AbstructLang } from '../../../components/general/general-component/abstruct-component/AbstructLang'
import { DeleteComponent } from '../../../components/general/general-component/abstruct-component/DeleteComponent'
import SectionTopOfTable from '../../../components/general/general-component/section-top-of-table/SectionTopOfTable'
import Warning from '../../../components/general/general-component/warning-delete/Warning'
import { VariableExpenses } from './VariableExpenses'
import { deleteExpense, loadExpenses } from '../../../store/Actions/ActionExpenses'
import FilterExpenses from './FilterExpenses'
import EditExpenses from './EditExpenses'
import AddExpenses from './AddExpenses'
import DetailsExpenses from './DetailsExpenses'
import ExpensesCard from '../../../components/cards/ExpensesCard'
import { PagenationCustom } from '../../../components/general/general-component/abstruct-component/PagenationCustom '
import SinglePagenation from '../../../components/general/pagination/SinglePagenation'
import { UsePermissions, hasPermissions } from '../../../components/general/general-component/abstruct-component/UsePermissions'
import CheckPermissions from '../../../components/general/general-component/check-permissions'
import CheckLazyLoader from '../../../components/general/general-component/check-lazy-loader'
import AccountInfo from '../accounts/report-account/AccountInfo'
import filter from '../../../assets/images/filter.png'
import { emptyOneAccount } from '../../../store/Actions/ActionAccounts'
import ExportExpenses from './ExportExpenses'


const AllExpenses = () => {
    const { permissionss, loadingMainPermission } = UsePermissions();
    const expensesPer = hasPermissions([{ name: "expenses" }], permissionss);
    const { dispatch, langLocal } = AbstructVar()
    const { translate } = AbstructLang()
    const { expenses, loadingExpenses,accountDetails } = useSelectorCustom()
    const { state, setOpen, setopenEdit, setOpenDetails , setOpenExport} = VariableExpenses()
    const { stateD, warning, setdeletee, setloadDel } = DeleteComponent()
    const [expensesArr, setExpensesArr] = useState([])
    const [isDeleted, setIsDeleted] = useState('')
    const [idDeleted, setIdDeleted] = useState(null)
    const [expense_id, setExpenseId] = useState(null)

    useEffect(() => {
        if (isDeleted && idDeleted) {
            const updatedArr = [...expensesArr];
            const indexToDelete = updatedArr.findIndex(item => item.id === idDeleted);
            if (indexToDelete !== -1) {
                updatedArr.splice(indexToDelete, 1);
                setExpensesArr(updatedArr);
            }
        }
    }, [isDeleted, idDeleted, expensesArr]);
    useEffect(() => {
        if (expenses?.length >= 0) {
            setExpensesArr(expenses)
        }
    }, [expenses]);
    useEffect(() => {
        return (() => {
            dispatch(emptyOneAccount())
        })
    }, []);
    const handleDelete = (id) => {
        dispatch(deleteExpense(id, setloadDel, setIsDeleted, setIdDeleted));
    }
    const openAddExpenses = e => {
        e.preventDefault()
        setOpen(true)
    }

    const openExportExpenses = e => {
        e.preventDefault()
        setOpenExport(true)
    }

    const detailsOfExpenses = (id) => {
        console.log(id)
        setExpenseId(id)
        setOpenDetails(true)
    }
    const { displayArr, pageCount, changePage } = PagenationCustom(expensesArr, 10)
    return (
        <CheckLazyLoader>
            <CheckPermissions array={expensesPer} loadingMainPermission={loadingMainPermission} >
                <main>
                    <div className="margin_main shadow_main">
                        <FilterExpenses translate={translate} titleExportBtn={translate('export_expenses')} FunctionExportBtn={openExportExpenses}/>
                    </div>
                    {
                        !loadingExpenses && (
                            <div className="margin_main shadow_main" style={{ backgroundColor: "white", marginTop: "20px", borderRadius: "5px" }}>
                                <AccountInfo data={accountDetails} />
                            </div>
                        )
                    }

                    <div className="div_table margin_main shadow_main" dir={langLocal == "ar" ? "rtl" : "ltr"} >
                        <SectionTopOfTable expenses={expenses} displayArr={displayArr} langLocal={langLocal} FunctionBtn={openAddExpenses} titleBtn={translate('add_expenses')}/>
     
                        <div className='all-expenses' >
                            {
                                expenses?.length > 0 ? (
                                    displayArr?.map((expense, index) => {
                                        return (
                                            <ExpensesCard langLocal={langLocal} warning={warning}
                                                detailsOfExpenses={detailsOfExpenses} index={index} expense={expense} translate={translate} />
                                        )
                                    })) : <div className='div-have-to-filter' >
                                    <img src={filter} />
                                    <span>{translate('have_to_filter')}</span>
                                </div>
                            }

                        </div>
                        <SinglePagenation pageCount={pageCount} changePage={changePage} />
                        <br></br>
                    </div>
                </main>
            </CheckPermissions>
            {
                stateD.deletee == true ? (
                    <Warning loadDel={stateD.loadDel} arr={stateD.arrW} open={stateD.deletee} setOpen={setdeletee} handleDelete={handleDelete} />
                ) : <></>
            }
            {
                state.open && (
                    <AddExpenses isStatment={true} open={state.open} setOpen={setOpen} />
                )
            }
            {
                state.openExport && (
                    <ExportExpenses isStatment={true} open={state.openExport} setOpen={setOpenExport} />
                )
            }
            {
                state.openEdit && (
                    <EditExpenses arr={state.arr1} open={state.openEdit} setOpen={setopenEdit} />
                )
            }
            {
                state.openDetails && (
                    <DetailsExpenses expense_id={expense_id} open={state.openDetails} setOpen={setOpenDetails} />
                )
            }
        </CheckLazyLoader>
    )
}

export default AllExpenses

